<div id="tid-ez-fmb-placement-container">
    <div class="tid-ez-fmbp-col" id="tid-ez-fmbp-front" [ngClass]="{'is-selected': isFrontPlacement}"></div>
    <div class="tid-ez-fmbp-col" id="tid-ez-fmbp-middle" [ngClass]="{'is-selected': isMiddlePlacement}">{{pinSheet.greenName}}</div>
    <div class="tid-ez-fmbp-col" id="tid-ez-fmbp-back" [ngClass]="{'is-selected': isBackPlacement}"></div>
</div>
